/* eslint-disable no-undef */
import React, { useState, createContext, useCallback } from "react";
import { movableColumnApi } from "../api";
import { showToast } from "../../components/Toast";
import { useUser } from "../hooks";
import { localStorageItemNames } from "../constants";
import { DEALEAR_DEFAULT } from "../constants/dealer-name";

/**
 * MovableColumn context
 */
export const MovableColumnContext = createContext();

/**
 * MovableColumn data provider
 */
export const MovableColumnProvider = ({ children }) => {
  const [movableColumn, setMovableColumn] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortedColumn, setSortedColumn] = useState([]);
  const { setColumnChange, setPopupBlock } = useUser();

  const [defaultColDef, setColumnDefs] = useState([]);

  const getMovableColumnApi = async (values) => {
    setLoading(true);
    setColumnChange(false);
    setPopupBlock(false);
    const response = await movableColumnApi.getMovableColumn({
      limit: values?.limit ? values.limit : 200,
      offset: values?.offset ? values.offset : 0,
      ...values,
      filter: {
        ...values?.filter,
      },
      sorting: {
        fieldName: "",
        direction: "",
      },
    });

    if (response?.error) {
      // addMessage({ message: response.error.response.error, type: "error" });
      setLoading(false);
      return true;
    }

    if (response?.data?.data) {
      const sanitizedData = response.data.data.map(dbRow => {
        if (dbRow.columnName) {
          try {
            const cols = JSON.parse(dbRow.columnName);
            cols.forEach(c => {
              if (c.minWidth && c.minWidth < 120) {
                c.minWidth = 120;
              }
            });
            dbRow.columnName = JSON.stringify(cols);
          } catch (e) { }
        }
        return dbRow;
      });
      setMovableColumn(sanitizedData);
      setLoading(false);
    } else {
      setMovableColumn([]);
      setLoading(false);
    }

    return response.data;
  };

  const updateViewMovableColumn = async (values) => {
    let payload = {
      filter: { companyId: values?.companyId },
      limit: 10000,
      offset: 0,
    };
    setLoading(true);
    const response = await movableColumnApi.editMovableColumn({ ...values });
    if (response?.error) {
      setLoading(false);
    }

    if (response?.data?.data) {
      await getMovableColumnApi({
        filter: {
          userId: values?.userId,
          pageName: values?.pageName,
          companyId: localStorage.getItem(localStorageItemNames.companyId),
          dealerId: DEALEAR_DEFAULT.dealerId,
        },
      });
      showToast("Movable Column updated successfully!");
    } else {
      setLoading(false);
      showToast("Something went wrong Try again!");
    }

    return response.data;
  };

  const createMovableColumn = async (values) => {
    setLoading(true);
    const response = await movableColumnApi.createMovableColumn(values);

    if (response?.error) {
      setLoading(false);
    }

    if (response?.data?.succeeded) {
      const userId = localStorage.getItem(localStorageItemNames.userID);
      await getMovableColumnApi({
        filter: {
          userId: userId,
          pageName: values?.pageName,
          companyId: localStorage.getItem(localStorageItemNames.companyId),
          dealerId: DEALEAR_DEFAULT.dealerId,
        },
      });
      // setMovableColumn(response?.data?.data);
      setLoading(false);
      showToast("Movable Column saved successfully!");
    } else {
      showToast("Something went wrong Try again!");
      setLoading(false);
    }
    return response.data;
  };

  const contextValue = {
    defaultColDef,
    setColumnDefs,
    sortedColumn,
    setSortedColumn,
    movableColumn,
    setMovableColumn,
    loading,
    setLoading,
    getMovableColumnApi: useCallback((request) => {
      getMovableColumnApi(request);
    }, []),
    updateViewMovableColumn: useCallback((request) => {
      updateViewMovableColumn(request);
    }, []),
    createMovableColumn: useCallback((request) => {
      createMovableColumn(request);
    }),
  };

  return (
    <MovableColumnContext.Provider value={contextValue}>
      {children}
    </MovableColumnContext.Provider>
  );
};
